import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { Identifier } from '../models/storage.model';

@Injectable({
  providedIn: 'root',
})
export class MenuGuardService {
  constructor(private router: Router) {}
  canActivate(
    route: ActivatedRouteSnapshot,
    // eslint-disable-next-line
    _state: RouterStateSnapshot
  ): boolean | UrlTree | Observable<boolean | UrlTree> | Promise<boolean | UrlTree> {
    const visibleMenusStorage = localStorage.getItem(Identifier.TYPE_VISIBLE_MENUS);
    const visibleMenus = visibleMenusStorage ? JSON.parse(visibleMenusStorage) : [];
    const menuId = +route.data['menuId'];
    if (visibleMenus && visibleMenus?.length > 0 && visibleMenus?.includes(menuId)) {
      return true;
    } else if (menuId === 1000 || menuId === 1001) {
      return this.router.parseUrl('/manage');
    }
    return this.router.parseUrl('/dashboard');
  }
}
